module.exports = __webpack_public_path__ + "static/img/cmdb_top.36183850.svg";